/**
 * Распашная дверь на 2D-чертеже — по правилам оформления строительных планов: разрыв
 * в стене, полотно и дуга открывания. Так рисуются обычная дверь и дверь под покраску.
 *
 * Компонент работает в локальной системе координат проёма: начало — левый край,
 * ось X идёт вдоль стены. Поворот и сдвиг задаёт родитель через transform.
 * Сторону петель и направление открывания задают флаги flipHinge / flipSwing:
 * они разворачивают символ зеркально, не трогая сам проём.
 */
import type { OpeningShapeProps } from "./DoorShape";

export const SwingDoorShape = ({
	opening,
	wallThickness,
	selected,
	mmPerPx,
	interactive,
	onPointerDown,
}: OpeningShapeProps) => {
	const t = wallThickness;
	const w = opening.width;
	const px = (n: number) => n * mmPerPx;
	const accent = selected ? "#2f6feb" : "#39414f";
	const swing = `translate(${opening.flipHinge ? w : 0} 0) scale(${opening.flipHinge ? -1 : 1} ${
		opening.flipSwing ? -1 : 1
	})`;

	return (
		<g>
			{/* Разрыв в стене */}
			<rect x={0} y={-t / 2} width={w} height={t} fill="#ffffff" />
			<g transform={swing}>
				<path
					d={`M 0 0 L 0 ${-w} A ${w} ${w} 0 0 1 ${w} 0`}
					fill="none"
					stroke={selected ? "#8ab0f5" : "#aab4c4"}
					strokeWidth={px(1.2)}
					strokeDasharray={`${px(6)} ${px(4)}`}
				/>
				<line x1={0} y1={0} x2={0} y2={-w} stroke={accent} strokeWidth={px(3)} />
			</g>
			{/* Откосы по краям проёма */}
			<line x1={0} y1={-t / 2} x2={0} y2={t / 2} stroke={accent} strokeWidth={px(1.5)} />
			<line x1={w} y1={-t / 2} x2={w} y2={t / 2} stroke={accent} strokeWidth={px(1.5)} />
			{/* Невидимая зона захвата для перетаскивания вдоль стены */}
			<rect
				data-role="opening"
				data-id={opening.id}
				x={0}
				y={-t / 2}
				width={w}
				height={t}
				fill="transparent"
				style={{
					cursor: interactive ? "grab" : "default",
					pointerEvents: interactive ? "auto" : "none",
				}}
				onPointerDown={onPointerDown}
			/>
		</g>
	);
};
